<a class="globe" href="/en">EN</a>

<style lang="scss">
  .globe {
    display: grid;
    place-content: center;
    width: 60px;
    position: relative;
    &::after {
      content: '';
      display: block;
      height: 36px;
      width: 1px;
      background-color: $color-medium-gray;
      position: absolute;
      left: 74px;
      top: 50%;
      translate: 0 -50%;
    }
  }
  @include mobile {
    .globe {
      &:after {
        left: 66px;
      }
    }
  }
</style>
